import "./style.scss";
import ApiTestHarness from "../../components/common/apiTestHarness";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Alert from "../../components/common/alert";
import {MESSAGES} from "../../constants";
import {clearSaveMyProfileErrors} from "../../actions/users";
import {clearGetApiResponseError, getApiResponse} from "../../actions/session";

export const route = '/api-testing';

const ApiTesting = () => {
  const [apiUrl, setApiUrl] = useState();
  const [apiRequestMade, setApiRequestMade] = useState(false);

  const userComposite = useSelector((state) => state.session.currentUserComposite);
  const sessionId = useSelector((state) => state.session.sessionData);
  const apiResponse = useSelector((state) => state.session.apiResponse);
  const apiResponseError = useSelector((state) => state.session.apiResponseError);

  const dispatch = useDispatch();

  const onSubmit = async (apiUrl, params) => {
    await setApiRequestMade(false);
    await dispatch(getApiResponse(apiUrl, params));
    await setApiRequestMade(true);
  }

  const onDismissAlert = () => {
    dispatch(clearGetApiResponseError());
  }

  return (
    <div className='main-content'>
      <div className='api-testing-alerts'>
        {apiResponseError && <Alert messageType='error' onDismiss={onDismissAlert}>{`${apiResponseError.message}${(apiResponseError.cause) ? `: ${apiResponseError.cause}` : ''}`}</Alert>}
      </div>
      <div className='api-testing-header'>
        Test the API
      </div>
      <div className='api-testing-container'>
        <div className='api-testing-message'>
          Note: Most requests for the Compass API require current username and session ID values in the query string<br /><br/>
          <span className='api-testing-message-label'>Example: </span>https://api.url/api/example?loggedInUserName=YOUR_USERNAME&sessionId=SESSION_ID
        </div>
        <div className='api-testing-current-values'>
          <span className='api-testing-message-label'>Current User:</span> {(userComposite) ? userComposite.user.username : 'N/A'}<br /><span className='api-testing-message-label'>Session ID:</span> {sessionId}
        </div>
        <div className='api-testing-form'>
          <ApiTestHarness apiUrl={apiUrl} changeApiUrl={setApiUrl} responseBody={apiResponse} submitAction={onSubmit}/>
        </div>
      </div>
    </div>
  )
}

export default ApiTesting;